/**
 * Auth Service
 * Handles API calls for user profile operations
 * Task 008 - Profile Page Enhancements
 */

import apiClient from '../lib/apiClient';

/**
 * User profile data interface
 */
export interface UserProfile {
  id: string;
  email: string;
  name?: string;
  onboarding_done: boolean;
  created_at: string;
  auth_provider?: string; // 'email' or 'google'
  preferred_currency?: string;
  thousand_separator?: string;
  language?: string;
}

/**
 * Update profile request interface
 */
export interface UpdateProfileData {
  name?: string;
  email?: string;
  preferred_currency?: string;
  thousand_separator?: string;
  language?: string;
}

/**
 * Change password request interface
 */
export interface ChangePasswordData {
  current_password: string;
  new_password: string;
}

/**
 * Update user profile (name and/or email)
 */
export const updateUserProfile = async (data: UpdateProfileData): Promise<UserProfile> => {
  return apiClient.put('/auth/profile', data);
};

/**
 * Get current user profile
 */
export const getCurrentUser = async (): Promise<UserProfile> => {
  return apiClient.get('/auth/me');
};

/**
 * Change user password
 * Only works for email/password users (not Google OAuth)
 */
export const changePassword = async (data: ChangePasswordData): Promise<{ message: string }> => {
  return apiClient.post('/auth/change-password', data);
};
